import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function useGiftOrder(giftOrderNo: string) {
    const { data, status } = useQuery(queries.giftOrder.detail(giftOrderNo));
    const { replace } = useFlow();
    const toast = useToast();
    const { t } = useTranslation('gift');
    useEffect(() => {
        if (status === 'error') {
            toast.error(t('giftOrderComplete.loadError'));
            replace('MainActivity', {});
        } else if (import.meta.env.MODE !== 'development' && status === 'success') {
            console.log('gift order complete');
        }
    }, [status]);
    return data;
}

export default useGiftOrder;
